module.exports = __webpack_public_path__ + "ef5bd23cdf8908ba09f0528777110f48.svg";